import React from 'react';
import { Card, CardContent } from './ui/card';
import { ExternalLink, FolderKanban, Globe2 } from 'lucide-react';

const PortfolioSection = ({ projects }) => (
  <section className="space-y-8" aria-labelledby="portfolio-heading">
    <div className="flex items-center animate-slideInRight">
      <div className="relative">
        <FolderKanban className="w-6 h-6 mr-2 text-blue-600 dark:text-blue-400" />
        <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full animate-ping" />
      </div>
      <div>
        <h2
          id="portfolio-heading"
          className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent"
        >
          Selected Portfolio
        </h2>
        <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
          Business websites and digital platforms I built and deployed.
        </p>
      </div>
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {projects.map((project) => {
        const isLive = project.status === 'Live';

        return (
          <Card
            key={project.id}
            className="group border border-blue-100 dark:border-blue-900 bg-white/90 dark:bg-gray-800/90 backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <CardContent className="p-6 h-full flex flex-col">
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-3">
                  <div className="p-2 rounded-lg bg-blue-100 dark:bg-blue-900">
                    <Globe2 className="w-5 h-5 text-blue-600 dark:text-blue-400" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                      {project.name}
                    </h3>
                    <p className="text-sm text-blue-600 dark:text-blue-400">
                      {project.category}
                    </p>
                  </div>
                </div>
                <span
                  className={`shrink-0 rounded-full px-2.5 py-1 text-xs font-medium ${
                    isLive
                      ? 'bg-green-100 text-green-700 dark:bg-green-900/60 dark:text-green-300'
                      : 'bg-amber-100 text-amber-700 dark:bg-amber-900/60 dark:text-amber-300'
                  }`}
                >
                  {project.status}
                </span>
              </div>

              <p className="mt-4 flex-1 text-gray-700 dark:text-gray-300 leading-relaxed">
                {project.description}
              </p>

              <a
                href={project.url}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 inline-flex items-center font-medium text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
              >
                Visit {project.name}
                <ExternalLink className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-1" />
              </a>
            </CardContent>
          </Card>
        );
      })}
    </div>
  </section>
);

export default PortfolioSection;
